import { Fragment, useEffect, useState } from "react";
import { generateUniqueId } from "../../../utils/utils";
import CustomModal from "../../CustomModal/CustomModal";
import { TrashIcon, XCircleIcon } from "@heroicons/react/24/outline";
import ExternalCourseAccordianAction from "../../AdminPageComponents/ExternalCourseAccordianAction/ExternalCourseAccordianAction";

const AddHeading = ({ setCourseCurriculum, chapterIndex }) => {
  const [show, setShow] = useState(false);
  const [headingName, setHeadingName] = useState("");

  const addHeading = (e) => {
    e.preventDefault();

    setCourseCurriculum((prev) => {
      const updatedSections = [...prev];
      const chapterToUpdate = {
        ...updatedSections[0]?.chapters?.[chapterIndex],
      };
      const headingToUpdate = [
        ...chapterToUpdate.headings,
        { name: headingName, _id: generateUniqueId(), topics: [] },
      ];
      chapterToUpdate.headings = headingToUpdate;
      updatedSections[0].chapters[chapterIndex] = chapterToUpdate;
      return updatedSections;
    });

    setHeadingName("");
    handleClose();
  };

  const handleClose = () => {
    setHeadingName("");
    setShow(false);
  };
  const handleShow = () => setShow(true);

  return (
    <Fragment>
      <button
        className="bg-white border border-purple1 px-4 py-2 text-purple1 text-sm font-inter font-medium rounded-md w-max hover:text-white hover:bg-purple1 transition-all ease-in-out duration-200 mt-3"
        onClick={handleShow}
      >
        Add Heading
      </button>
      <CustomModal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        {show && (
          <>
            <div className="flex items-center justify-between border-b w-full py-4">
              <h4 className="text-base font-inter font-medium text-black pl-5">
                Add New Heading
              </h4>
              <XCircleIcon
                className="text-gray-400 h-6 w-6 mr-4 cursor-pointer"
                onClick={handleClose}
              />
            </div>
            <div className="w-full flex flex-col px-6 pt-5 pb-2">
              <div className="mb-3">
                <input
                  type="text"
                  placeholder="Add new lecture"
                  value={headingName}
                  onChange={(e) => setHeadingName(e.target.value)}
                  className="px-4 py-2 outline-none border border-gray19 rounded-tl-md rounded-bl-md text-sm font-inter font-medium placeholder:text-gray20 text-gray18 w-full"
                />
              </div>
            </div>
            <div className="w-full flex items-center space-x-4 px-6 pb-5">
              <button
                className="bg-purple1 px-4 py-2 text-white text-sm font-inter font-medium rounded-md"
                onClick={addHeading}
              >
                Add New Heading
              </button>
              <button
                className="bg-white px-4 py-2 text-black/70 text-sm font-inter font-medium rounded-md border-gray22 border"
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </>
        )}
      </CustomModal>
    </Fragment>
  );
};

const AddChapter = ({ setCourseCurriculum }) => {
  const [show, setShow] = useState(false);
  const [chapterName, setChapterName] = useState("");

  const addChapter = (e) => {
    e.preventDefault();
    const sectionToBeAdded = {
      _id: generateUniqueId(),
      name: chapterName,
      headings: [],
    };
    setCourseCurriculum((prev) => {
      const updatedSections = [...prev];
      const chapterToUpdate = [
        ...updatedSections[0]?.chapters,
        sectionToBeAdded,
      ];
      updatedSections[0].chapters = chapterToUpdate;
      return updatedSections;
    });
    setChapterName("");
    handleClose();
  };

  const handleClose = () => {
    setChapterName("");
    setShow(false);
  };
  const handleShow = (e) => {
    e.preventDefault();
    setShow(true);
  };

  return (
    <Fragment>
      <button
        className="bg-white border border-purple1 px-4 py-2 text-purple1 text-sm font-inter font-medium rounded-md w-max hover:text-white hover:bg-purple1 transition-all ease-in-out duration-200"
        onClick={handleShow}
      >
        Add Chapter
      </button>
      <CustomModal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        {show && (
          <>
            {/* modal header */}
            <div className="flex items-center justify-between border-b w-full py-4">
              <h4 className="text-base font-inter font-medium text-black pl-5">
                Add New Chapter
              </h4>
              <XCircleIcon
                className="text-gray-400 h-6 w-6 mr-4 cursor-pointer"
                onClick={handleClose}
              />
            </div>
            {/* modal body */}
            <div className="w-full flex flex-col px-6 py-5">
              <div className="pb-0">
                <div className="mb-3">
                  <input
                    type="text"
                    placeholder="Add new section"
                    value={chapterName}
                    onChange={(e) => setChapterName(e.target.value)}
                    className="px-4 py-2 outline-none border border-gray19 rounded-tl-md rounded-bl-md text-sm font-inter font-medium placeholder:text-gray20 text-gray18 w-full"
                  />
                </div>
              </div>
              <div className="flex items-center space-x-4">
                <button
                  className="bg-purple1 px-4 py-2 text-white text-sm font-inter font-medium rounded-md"
                  onClick={addChapter}
                >
                  Add New Chapter
                </button>
                <button
                  className="bg-white px-4 py-2 text-black/70 text-sm font-inter font-medium rounded-md border-gray22 border"
                  onClick={handleClose}
                >
                  Close
                </button>
              </div>
            </div>
          </>
        )}
      </CustomModal>
    </Fragment>
  );
};

const ExternalCourseCurriculum = (props) => {
  // destructuring props
  const { next, previous, usedForEdit, handleChange } = props;
  // curriculum local state
  const [courseCurriculum, setCourseCurriculum] = useState(
    props?.data?.grades ? props?.data?.grades : []
  );

  // handler func. to go to next step in add course
  const handleNextClick = () => {
    const event = { target: { name: "grades", value: courseCurriculum } };
    handleChange(event);
    next();
  };

  // handler func. to delete the chapetr
  const deleteChapter = (chapterIndex) => {
    setCourseCurriculum((prev) => {
      const updatedSections = [...prev];
      updatedSections[0].chapters.splice(chapterIndex, 1); // Remove the heading at the specified index
      return updatedSections;
    });
  };

  // if using for edit save the curriculum object on each change in the local object
  useEffect(() => {
    if (usedForEdit) {
      const event = { target: { name: "grades", value: courseCurriculum } };
      handleChange(event);
    }
  }, [courseCurriculum, usedForEdit]);

  console.log(courseCurriculum);

  return (
    <>
      {/* Card */}
      <div className="w-full mb-3 bg-white shadow-md rounded-md border flex flex-col items-start">
        <div className="border-b px-6 py-3 w-full">
          <h4 className="text-base font-inter font-semibold text-black">
            Curriculum
          </h4>
        </div>
        {/* Card body */}
        <div className="px-6 py-3 flex flex-col space-y-4 w-full">
          {courseCurriculum?.[0]?.chapters?.map((curriculum, index) => (
            <div className="bg-gray21 rounded p-2 mb-4" key={index}>
              <div className="flex items-center space-x-4 justify-between">
                <h4>{curriculum?.name}</h4>
                <TrashIcon
                  className="h-4 w-4 md:h-5 md:w-5 text-red-500 cursor-pointer"
                  onClick={() => deleteChapter(index)}
                />
              </div>
              {/* Item list */}
              <ExternalCourseAccordianAction
                setCourseCurriculum={setCourseCurriculum}
                chapterId={curriculum?._id}
                chapterIndex={index}
                accordionItems={curriculum?.headings}
                courseCurriculum={courseCurriculum}
              />
              <AddHeading
                setCourseCurriculum={setCourseCurriculum}
                chapterIndex={index}
              />
            </div>
          ))}
          <AddChapter setCourseCurriculum={setCourseCurriculum} />
        </div>
      </div>
      {/* Button */}
      {props?.next && props?.previous && (
        <div className="flex justify-between">
          <button
            className="bg-gray22 px-4 py-2 text-white text-sm font-inter font-medium rounded-md"
            onClick={previous}
          >
            Previous
          </button>
          <button
            className="bg-purple1 px-4 py-2 text-white text-sm font-inter font-medium rounded-md"
            onClick={handleNextClick}
          >
            Next
          </button>
        </div>
      )}
    </>
  );
};
export default ExternalCourseCurriculum;
